import { actionCreatorFactory } from 'typescript-fsa';
import { NAMESPACE } from './index';
import { FlashMessage } from '@pegasus/ui-flashmessages/types/flashmessage';

export const createAction = actionCreatorFactory(NAMESPACE);
export const addClientFlashMessage = createAction<FlashMessage>('ADD_MESSAGE');
